import { Permission } from "~/models/dto";

import { usePermissions } from "../common/use-permissions";
import { useQuery } from "../queries/react-query";
import { queryUIConfig, selectEnableAi } from "../queries/ui-config";

export const useAiAssistantAvailability = (): boolean => {
	const { data: enableAi = false } = useQuery({
		...queryUIConfig,
		select: selectEnableAi,
	});
	const hasExecuteAiPermission = usePermissions((permissions) => permissions.hasSystemPermission(Permission.ExecuteAi));

	return enableAi && (hasExecuteAiPermission ?? false);
};
